import { render, staticRenderFns } from "./index_com.vue?vue&type=template&id=067c3c08&scoped=true&"
import script from "./index_com.vue?vue&type=script&lang=js&"
export * from "./index_com.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scene.less?vue&type=style&index=0&id=067c3c08&lang=less&scoped=true&"
import style1 from "./index_com.vue?vue&type=style&index=1&id=067c3c08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067c3c08",
  null
  
)

export default component.exports